import {Dispatch, SetStateAction} from 'react'

export type ID = undefined | null | number | string

export type PaginationState = {
  pageNumber?: number | undefined
  page?: number | undefined
  pageSize?: 2 | 10 | 30 | 50 | 100
  totalRecordsFiltered?: number
  links?: Array<{
    label: string
    active: boolean
    url: string | null
    page: number | null
  }>
  id?: number | undefined
  additionalData?: any
  totalPages?: number | undefined
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
  sortName?: string
  sortDir?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: any
}

export type SearchState = {
  search?: string
  keyword?: string
}

export type Response<T> = {
  code: string
  data?: T
  message?: string
  payload?: {
    message?: string
    errors?: {
      [key: string]: Array<string>
    }
    pagination?: PaginationState
  }
}

export type QueryState = PaginationState & SortState & FilterState & SearchState

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  pageNumber: 1,
  pageSize: 10,
  search: '',
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<any> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
  fetchData?: any
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>
  selectedItemId?: ID
  setSelectedItemId?: Dispatch<SetStateAction<ID>>
  isAllSelected: boolean
  disabled: boolean
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  setSelectedItemId: () => {},
  isAllSelected: false,
  disabled: false,
}

export const debouceTimeout = 1000

export const intervalRefreshRecaptcha = 90 * 1000
